import B1 from "../../../Images/New/ImageView/1.jpg";
import B2 from "../../../Images/New/ImageView/2.jpg";
import B3 from "../../../Images/New/ImageView/3.jpg";
import B4 from "../../../Images/New/ImageView/4.jpg";
import B5 from "../../../Images/New/ImageView/5.jpg";
import B6 from "../../../Images/New/ImageView/6.jpg";
import B7 from "../../../Images/New/ImageView/7.jpg";
import B8 from "../../../Images/New/ImageView/8.jpg";

const moduleData = [
  {
    name: "TDS Dashboard",
    back: B1,
  },
  {
    name: "Online Tool",
    back: B2,
  },
  {
    name: "24Q Dashboard",
    back: B3,
  },
  {
    name: "TDS Employee salary",
    back: B4,
  },
  {
    name: "Corrections",
    back: B5,
  },
  {
    name: "TDS Reports",
    back: B6,
  },
  {
    name: "Import",
    back: B7,
  },
  {
    name: "15G-15H",
    back: B8,
  },
];

export default moduleData;

